import axios from './axios';

export default class Roster {
  static getRosterForCohort(_, cohortId) {
    return axios.get(`/paths/bootcamp_instances/${cohortId}/roster`).then(response => response.data);
  }
}
